import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './security/_components/login/login.component';
import { PanelComponent } from './panel/panel.component';

const routes: Routes = [
  // URL publiques:
  { path: 'login', component: LoginComponent },
  { path: '', loadChildren: './panel/panel.module#PanelModule' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRouting { }
